<script lang="ts">
import { RequestActionType } from '@/app/common/types/requestAction.type';
import { PropType } from 'vue';

export default {
    components: {
    },
    setup() {
    },
    props: {
        modelValue: {
            type: Array as PropType<RequestActionType[]>,
            default: () => []
        },
        title: {
            type: String,
            default: ""
        },
        subTitle: {
            type: String,
            default: ""
        },
        isCompact: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'update:modelValue',
        'doCancelRequest',
        'doSendRequestAgain',
        'doUserSave',
        'doExportPdf',
        'doNeedAdditionalDocs',
        'doVerifyAdditionalDocs',
        'doAscSave',
        'doDpmSave',
        'doSendToDepartment',
        'doSendToAirline',
        'doSendDocsToDepartment',
        'doSummaryOfOperation',
        'doSendBackToAsc',
        'doNotifyCancelRequest',
        'doAirlineSave',
        'doSubmitToDepartment',
        'doReturnToDepartment',
        'doReturnToOcpb',
        'doReturnToOpm', //TODO: opm have return??
        'viewHistory',
    ],
    data() {
        return {

        }
    },
    watch: {
    },
    computed: {
        model: {
            get() {
                return this.modelValue.filter(o => !o.disabled) || [];
            },
            set(newValue: RequestActionType[]) {
                this.$emit('update:modelValue', newValue);
            }
        }
    },
    async mounted() {
    },
    methods: {
        doCallBack(callBackName: any) {
            this.$emit(callBackName);
        }
    },
};
</script>
<template>
    <v-row class="app-breadcrumb d-flex justify-space-between align-center px-1">
        <v-col cols="12" :sm="model.length > 2 ? 12 : 3" :md="model.length > 2 ? 12 : 3" lg="2" class="breadcrumb-title"
            :class="model && model.length !== 0 && model.length <= 2 ? 'label-extra-width' : !model || model.length === 0 ? 'mt-6 mb-3' : ''">
            <h2 class="text-uppercase font-weight-bold">{{ title }}</h2>
            <h5>{{ subTitle }}</h5>
        </v-col>
        <v-col cols="12" :sm="model.length > 2 ? 12 : 9" :md="model.length > 2 ? 12 : 9" lg="10"
            class="d-flex align-center justify-end" :class="model.length <= 2 ? 'ul-fit' : ''">
            <v-breadcrumbs :items="model" class="breadcrumb-wrapper">
                <template v-slot:title="{ item, index }">
                    <v-btn variant="flat" :prepend-icon="model[index].prependIcon"
                        :append-icon="model[index].appendIcon ?? ''" :color="model[index].btnColor.toString()"
                        :class="`text-${model[index].txtColor}`" @click="doCallBack(model[index].callBackFn)"
                        :size="isCompact ? undefined : 'large'" :style="{ 'height': isCompact ? '40px !important' : '' }">
                        <span :style="{ 'font-size': isCompact ? '13.5px !important' : '' }">
                            {{ $t(`t-${model[index].title}`)}}
                        </span>
                    </v-btn>
                </template>
                <template #divider>
                </template>
            </v-breadcrumbs>
        </v-col>
    </v-row>
</template>